// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__0zU3n","spin":"Spinner_spin__YGwlj"};